import axios from 'axios';
import RuleAliasSummary from '../entity/rule-alias-summary.entity';
import Rule from '../entity/rule.entity';
import ItemRuleAliasSummary from '../entity/item-rule-alias-summary.entity'

export default class RuleService {
  public static getRules(): Promise<Rule[]> {
    return axios.get('/api/v1/rules')
      .then((response: any) => Rule.ofList(response.data))
  }

  public static getBusinessUnitRuleAlias(businessUnitId: string): Promise<RuleAliasSummary[]> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/rules/alias`)
      .then((response: any) => RuleAliasSummary.ofList(response.data))
  }

  public static saveRuleAlias(
    businessUnitId: string, ruleAliasSummary: RuleAliasSummary,
  ): Promise<void> {
    return axios.put(`/api/v1/business-units/${businessUnitId}/rules/${ruleAliasSummary.ruleId}/alias`, ruleAliasSummary)
  }

  public static getContractItemRuleAlias(businessUnitId: string, contractItemId: string)
  : Promise<ItemRuleAliasSummary[]> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/contractItem/${contractItemId}/rules/alias`)
      .then((response: any) => ItemRuleAliasSummary.ofList(response.data))
  }

  public static saveItemRuleAlias(
    businessUnitId: string, contractItemId: string, ruleAliasSummary: ItemRuleAliasSummary,
  ): Promise<void> {
    return axios.put(`/api/v1/business-units/${businessUnitId}/contract-items/${contractItemId}/rules/alias`, ruleAliasSummary)
  }

  public static getRestrictRulesPerProfile(businessUnitId: string, profile: string)
  : Promise<Rule[]> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/rules/${profile}/restrict`)
      .then((response: any) => Rule.ofList(response.data))
  }
}
